import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import { required } from './validation/validation'
import renderSelectField from '../app-form/field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Spinner from '../spinner'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'
import HowToCreateViewDialog from '../how-to-create-view-dialog'

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
    margin: '0 auto',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  chipLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },

  list: {
    marginTop: 24,
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
})

class GAForm extends Component {
  state = {
    username: window.state.google_analytics_client.username,
    avatar: window.state.google_analytics_client.avatar,
    settings: window.state.google_analytics_accounts,
    selectedAccount: null,
    selectedProperty: null,
    selectedView: null,
    botFilteringEnabled: false,
  }

  handleChangeAccount = event => {
    this.setState({ selectedAccount: event.target.value })
  }

  handleChangeProperty = event => {
    this.setState({ selectedProperty: event.target.value })
  }

  handleChangeView = event => {
    this.setState({ selectedView: event.target.value })
    this.loadSelectedViewData(event.target.value)
  }

  handleDelete() {
    window.location.href = '/wizard/ga/delete'
  }

  loadSelectedViewData(viewId) {

    const {
      initialAccount,
    } = this.props

    const {
      selectedAccount,
      selectedProperty,
      settings,
    } = this.state

    let account =
      !selectedAccount && !initialAccount[0]
        ? []
        : !selectedAccount
        ? initialAccount[0]
        : settings.filter(account => {
          return account.id === this.state.selectedAccount
        })

    let properties =
      !selectedAccount && !initialAccount[0]
        ? []
        : selectedAccount
        ? account[0].web_properties
        : initialAccount[0].web_properties

    let property = account[0]
      ? properties.filter(property => property.id === selectedProperty)
      : !selectedProperty
        ? properties.filter(property => property.selected)
        : properties.filter(property => property.id === selectedProperty)

    const url = '/ga/view/'
      + account.id + '/'
      + property[0].id + '/'
      + viewId

    const json = response => {
      return response.json()
    }

    this.setState({ botFilteringEnabled: false })

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(data => {
        if (data.bot_filtering_enabled === true) {
          this.setState({ botFilteringEnabled: true })
        }
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentDidMount() {
    this.setState({ botFilteringEnabled: this.props.botFilteringEnabled })
  }

  render() {
    const { classes, handleSubmit, initialAccount, isFetching } = this.props
    const {
      username,
      avatar,
      selectedProperty,
      settings,
      selectedAccount,
      selectedView,
      botFilteringEnabled,
    } = this.state

    let account =
      !selectedAccount && !initialAccount[0]
        ? []
        : !selectedAccount
        ? initialAccount[0]
        : settings.filter(account => {
            return account.id === this.state.selectedAccount
          })

    let properties =
      !selectedAccount && !initialAccount[0]
        ? []
        : selectedAccount
        ? account[0].web_properties
        : initialAccount[0].web_properties

    let property = account[0]
      ? properties.filter(property => property.id === selectedProperty)
      : !selectedProperty
      ? properties.filter(property => property.selected)
      : properties.filter(property => property.id === selectedProperty)

    let views = property && property.length ? property[0].views : []

    let view = selectedView
      ? views.filter(view => view.id === selectedView)
      : views.filter(view => view.selected)

    const accountList = () => {
      return this.state.settings.map(account => {
        return (
          <MenuItem value={account.id} key={account.id}>
            {account.name}
          </MenuItem>
        )
      })
    }

    const propertyList = () => {
      return properties.map(property => {
        return (
          <MenuItem key={property.id} value={property.id}>
            {property.name} ({property.id})
          </MenuItem>
        )
      })
    }

    const viewList = () => {
      return views.map(view => {
        return (
          <MenuItem key={view.id} value={view.id}>
            {view.name}
          </MenuItem>
        )
      })
    }

    return (
      <form onSubmit={handleSubmit} className={classes.form}>
        <Chip
          avatar={<Avatar alt="" src={avatar} />}
          label={username}
          onDelete={this.handleDelete}
          className={classes.chip}
          variant="outlined"
          color="secondary"
          classes={{
            root: classes.root,
            colorSecondary: classes.colorSecondary,
            deleteIconOutlinedColorSecondary: classes.deleteIcon,
            label: classes.chipLabel,
          }}
        />

        <Field
          name="account"
          component={renderSelectField}
          onChange={this.handleChangeAccount}
          validate={[required]}
        >
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите аккаунт GA
            </span>
          </MenuItem>
          {accountList()}
        </Field>

        <Field
          name="web_property"
          onChange={this.handleChangeProperty}
          component={renderSelectField}
          validate={[required]}
        >
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите ресурс в этом аккаунте
            </span>
          </MenuItem>
          {propertyList()}
        </Field>

        <Field
          name="view"
          onChange={this.handleChangeView}
          component={renderSelectField}
          validate={[required]}
        >
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите представление
            </span>
          </MenuItem>
          {viewList()}
        </Field>

        {botFilteringEnabled ? (
          <Typography variant="subtitle1" paragraph>
            В настройках представления включена настройка "Исключить обращения роботов и "пауков"". Нажимая на кнопку "Сохранить конфигурацию", вы соглашаетесь на автоматическое отключение этой настройки — это необходимо для корректного отображения статистики.
          </Typography>
        ) : null}

        <ButtonContained
          style={{
            height: 48,
            marginBottom: 30,
            fontSize: 16,
            width: '100%',
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          text={isFetching ? <Spinner /> : 'Сохранить конфигурацию'}
        />

        <Typography variant="body1" paragraph style={{ marginTop: 24 }}>
          При передаче данных рекомендуем создать новое представление в Google Analytics. (Если ранее не создавали новое представления для сервиса ROMI center)
        </Typography>

        <ul className={classes.list}>
          <li className={classes.item}>
            <HowToCreateViewDialog />
          </li>
        </ul>
      </form>
    )
  }
}

GAForm = reduxForm({
  form: 'GAForm',
  enableReinitialize: true,
})(GAForm)

export default withStyles(styles)(GAForm)
